// src/reducers/dashboardadmin_reducers.js

import {
    FETCH_ADMIN_USER_STATS_LOADING,
    FETCH_ADMIN_USER_STATS_SUCCESS,
    FETCH_ADMIN_USER_STATS_FAIL,
    FETCH_ADMIN_RECIPES_STATS_LOADING,
    FETCH_ADMIN_RECIPES_STATS_SUCCESS,
    FETCH_ADMIN_RECIPES_STATS_FAIL,
    FETCH_ADMIN_CUSTOM_RECIPES_STATS_LOADING,
    FETCH_ADMIN_CUSTOM_RECIPES_STATS_SUCCESS,
    FETCH_ADMIN_CUSTOM_RECIPES_STATS_FAIL,
    FETCH_ADMIN_MAKE_RECIPES_STATS_LOADING,
    FETCH_ADMIN_MAKE_RECIPES_STATS_SUCCESS,
    FETCH_ADMIN_MAKE_RECIPES_STATS_FAIL,
    FETCH_ADMIN_LIKE_RECIPES_STATS_LOADING,
    FETCH_ADMIN_LIKE_RECIPES_STATS_SUCCESS,
    FETCH_ADMIN_LIKE_RECIPES_STATS_FAIL,
    FETCH_ADMIN_VIEW_RECIPES_STATS_LOADING,
    FETCH_ADMIN_VIEW_RECIPES_STATS_SUCCESS,
    FETCH_ADMIN_VIEW_RECIPES_STATS_FAIL,
    FETCH_ADMIN_BRANDS_STATS_LOADING,
    FETCH_ADMIN_BRANDS_STATS_SUCCESS,
    FETCH_ADMIN_BRANDS_STATS_FAIL,
    FETCH_ADMIN_BRAND_CATEGORY_STATS_LOADING,
    FETCH_ADMIN_BRAND_CATEGORY_STATS_SUCCESS,
    FETCH_ADMIN_BRAND_CATEGORY_STATS_FAIL,
    FETCH_ADMIN_BLOG_STATS_LOADING,
    FETCH_ADMIN_BLOG_STATS_SUCCESS,
    FETCH_ADMIN_BLOG_STATS_FAIL,
    FETCH_ADMIN_BLOG_NEWS_STATS_LOADING,
    FETCH_ADMIN_BLOG_NEWS_STATS_SUCCESS,
    FETCH_ADMIN_BLOG_NEWS_STATS_FAIL,
    FETCH_ADMIN_USER_ADDITIONAL_LOADING,
    FETCH_ADMIN_USER_ADDITIONAL_SUCCESS,
    FETCH_ADMIN_USER_ADDITIONAL_FAIL,
    FETCH_ADMIN_CURATED_RECIPES_ADDL_LOADING,
    FETCH_ADMIN_CURATED_RECIPES_ADDL_SUCCESS,
    FETCH_ADMIN_CURATED_RECIPES_ADDL_FAIL,
    FETCH_ADMIN_CUSTOM_RECIPES_ADDL_LOADING,
    FETCH_ADMIN_CUSTOM_RECIPES_ADDL_SUCCESS,
    FETCH_ADMIN_CUSTOM_RECIPES_ADDL_FAIL,
    FETCH_ADMIN_MAKE_RECIPE_ADDL_LOADING,
    FETCH_ADMIN_MAKE_RECIPE_ADDL_SUCCESS,
    FETCH_ADMIN_MAKE_RECIPE_ADDL_FAIL,
    FETCH_LIKE_RECIPE_ADDITIONAL_REQUEST,
    FETCH_LIKE_RECIPE_ADDITIONAL_SUCCESS,
    FETCH_LIKE_RECIPE_ADDITIONAL_FAIL,
    FETCH_VIEW_RECIPE_ADDITIONAL_REQUEST,
    FETCH_VIEW_RECIPE_ADDITIONAL_SUCCESS,
    FETCH_VIEW_RECIPE_ADDITIONAL_FAIL,
    FETCH_ADMIN_BRAND_ADDITIONAL_LOADING,
    FETCH_ADMIN_BRAND_ADDITIONAL_SUCCESS,
    FETCH_ADMIN_BRAND_ADDITIONAL_FAIL,
    FETCH_ADMIN_BRAND_CATEGORY_ADDITIONAL_LOADING,
    FETCH_ADMIN_BRAND_CATEGORY_ADDITIONAL_SUCCESS,
    FETCH_ADMIN_BRAND_CATEGORY_ADDITIONAL_FAIL,
    FETCH_ADMIN_BLOG_ADDITIONAL_LOADING,
    FETCH_ADMIN_BLOG_ADDITIONAL_SUCCESS,
    FETCH_ADMIN_BLOG_ADDITIONAL_FAIL,
    FETCH_ADMIN_BLOG_STATISTICS_ADDITIONAL_LOADING,
    FETCH_ADMIN_BLOG_STATISTICS_ADDITIONAL_SUCCESS,
    FETCH_ADMIN_BLOG_STATISTICS_ADDITIONAL_FAIL
} from '../actions/types';

const INITIAL_STATE = {
    adminStats: {
    total:     0,
    dateswise: []
    },
    loadingAdminStats: false,
    adminStatsError:   null,
    // Curated Recipes slice
    curatedRecipesStats:        { total: 0, dateswise: [] },
    loadingCuratedRecipesStats: false,
    curatedRecipesStatsError:   null,
    // Custom Recipes slice
    customRecipesStats:        { total: 0, dateswise: [] },
    loadingCustomRecipesStats: false,
    customRecipesStatsError:   null,
    // Total Makes slice
    makeRecipesStats:        { total: 0, dateswise: [] },
    loadingMakeRecipesStats: false,
    makeRecipesStatsError:   null,
    // Total Recipe Likes Slice
    likeRecipesStats:        { total: 0, dateswise: [] },
    loadingLikeRecipesStats: false,
    likeRecipesStatsError:   null,
    //Total Recipe Views Slice
    viewRecipesStats:        { total: 0, dateswise: [] },
    loadingViewRecipesStats: false,
    viewRecipesStatsError:   null,
    // Brand slice
    brandsStats:        { total: 0, dateswise: [] },
    loadingBrandsStats: false,
    brandsStatsError:   null,

    // ── Brand Category slice ─────────────────────
    brandCategoryStats:        { total: 0, dateswise: [] },
    loadingBrandCategoryStats: false,
    brandCategoryStatsError:   null,

    // Blog/News slice
    blogStats:        { total: 0, dateswise: [] },
    loadingBlogStats: false,
    blogStatsError:   null,

    // Blog/News View Statistic Redux slice
    blogNewsStats:        { total: 0, dateswise: [] },
    loadingBlogNewsStats: false,
    blogNewsStatsError:   null,

  // Additional: full user‐table dump
    userAdditionalData:        [],
    loadingUserAdditionalData: false,
    userAdditionalDataError:   null,

  // Curated Recipes “additional” details slice
    curatedRecipesAdditionalData:        [],
    loadingCuratedRecipesAdditionalData: false,
    curatedRecipesAdditionalDataError:   null,

  // Custom Recipes “additional” details slice
    customRecipesAdditionalData:        [],
    loadingCustomRecipesAdditionalData: false,
    customRecipesAdditionalDataError:   null,

  // Make‐Recipe “additional” slice
    makeRecipeAdditionalData:        [],
    loadingMakeRecipeAdditionalData: false,
    makeRecipeAdditionalDataError:   null,    

  //Like-Recipe "additional" slice
    likeRecipeAdditionalData: [],
    loadingLikeRecipeAdditionalData: false,
    likeRecipeAdditionalDataError: null,

  //View-Recipe "additional" slice
    viewRecipeAdditionalData: [],
    loadingViewRecipeAdditionalData: false,
    viewRecipeAdditionalDataError: null,

  // Brand “additional” slice for expanded‐view
    brandAdditionalData:        [],
    loadingBrandAdditionalData: false,
    brandAdditionalDataError:   null,

  // Brand‐Category “additional” slice
    brandCategoryAdditionalData:        [],
    loadingBrandCategoryAdditionalData: false,
    brandCategoryAdditionalDataError:   null,

  // Blog “additional” slice
    blogAdditionalData:        [],
    loadingBlogAdditionalData: false,
    blogAdditionalDataError:   null,

  // Blog‐Statistics “additional” slice
    blogStatisticsAdditionalData:        [],
    loadingBlogStatisticsAdditionalData: false,
    blogStatisticsAdditionalDataError:   null,
};

const dashboardAdminReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_ADMIN_USER_STATS_LOADING:
      return {
        ...state,
        loadingAdminStats: true,
        adminStatsError:   null
      };

    case FETCH_ADMIN_USER_STATS_SUCCESS:
      return {
        ...state,
        loadingAdminStats: false,
        adminStats:        action.payload,
        adminStatsError:   null
      };

    case FETCH_ADMIN_USER_STATS_FAIL:
      return {
        ...state,
        loadingAdminStats: false,
        adminStats:        INITIAL_STATE.adminStats,
        adminStatsError:   action.payload
      };
    
    // ── Curated Recipes ───────────────────
    case FETCH_ADMIN_RECIPES_STATS_LOADING:
      return {
        ...state,
        loadingCuratedRecipesStats: true,
        curatedRecipesStatsError:   null
      };

    case FETCH_ADMIN_RECIPES_STATS_SUCCESS:
      return {
        ...state,
        loadingCuratedRecipesStats: false,
        curatedRecipesStats:        action.payload,
        curatedRecipesStatsError:   null
      };

    case FETCH_ADMIN_RECIPES_STATS_FAIL:
      return {
        ...state,
        loadingCuratedRecipesStats: false,
        curatedRecipesStats:        INITIAL_STATE.curatedRecipesStats,
        curatedRecipesStatsError:   action.payload
      };

    case FETCH_ADMIN_CUSTOM_RECIPES_STATS_LOADING:
      return {
        ...state,
        loadingCustomRecipesStats: true,
        customRecipesStatsError:   null
      };

    case FETCH_ADMIN_CUSTOM_RECIPES_STATS_SUCCESS:
      return {
        ...state,
        loadingCustomRecipesStats: false,
        customRecipesStats:        action.payload,
        customRecipesStatsError:   null
      };

    case FETCH_ADMIN_CUSTOM_RECIPES_STATS_FAIL:
      return {
        ...state,
        loadingCustomRecipesStats: false,
        customRecipesStats:        INITIAL_STATE.customRecipesStats,
        customRecipesStatsError:   action.payload
      };

    // ── Total Makes ────────────────────────
    case FETCH_ADMIN_MAKE_RECIPES_STATS_LOADING:
      return {
        ...state,
        loadingMakeRecipesStats: true,
        makeRecipesStatsError:   null
      }

    case FETCH_ADMIN_MAKE_RECIPES_STATS_SUCCESS:
      return {
        ...state,
        loadingMakeRecipesStats: false,
        makeRecipesStats:        action.payload,
        makeRecipesStatsError:   null
      }

    case FETCH_ADMIN_MAKE_RECIPES_STATS_FAIL:
      return {
        ...state,
        loadingMakeRecipesStats: false,
        makeRecipesStats:        INITIAL_STATE.makeRecipesStats,
        makeRecipesStatsError:   action.payload
      }

    // ── Total Recipe Likes ────────────────────────

    case FETCH_ADMIN_LIKE_RECIPES_STATS_LOADING:
      return {
        ...state,
        loadingLikeRecipesStats: true,
        likeRecipesStatsError:   null
      };

    case FETCH_ADMIN_LIKE_RECIPES_STATS_SUCCESS:
      return {
        ...state,
        loadingLikeRecipesStats: false,
        likeRecipesStats:        action.payload,
        likeRecipesStatsError:   null
      };

    case FETCH_ADMIN_LIKE_RECIPES_STATS_FAIL:
      return {
        ...state,
        loadingLikeRecipesStats: false,
        likeRecipesStats:        INITIAL_STATE.likeRecipesStats,
        likeRecipesStatsError:   action.payload
      };

   // ── Total Views ───────────────────────────────────
    case FETCH_ADMIN_VIEW_RECIPES_STATS_LOADING:
      return { 
        ...state, 
        loadingViewRecipesStats: true, 
        viewRecipesStatsError: null 
    };
    case FETCH_ADMIN_VIEW_RECIPES_STATS_SUCCESS:
      return { 
        ...state, 
        loadingViewRecipesStats: false, 
        viewRecipesStats: action.payload, 
        viewRecipesStatsError: null 
    };
    case FETCH_ADMIN_VIEW_RECIPES_STATS_FAIL:
      return { 
        ...state, 
        loadingViewRecipesStats: false, 
        viewRecipesStats: INITIAL_STATE.viewRecipesStats, 
        viewRecipesStatsError: action.payload 
    };

    // ── Brand slice ──────────────────────────
    case FETCH_ADMIN_BRANDS_STATS_LOADING:
      return {
        ...state,
        loadingBrandsStats: true,
        brandsStatsError:   null
      };

    case FETCH_ADMIN_BRANDS_STATS_SUCCESS:
      return {
        ...state,
        loadingBrandsStats: false,
        brandsStats:        action.payload,
        brandsStatsError:   null
      };

    case FETCH_ADMIN_BRANDS_STATS_FAIL:
      return {
        ...state,
        loadingBrandsStats: false,
        brandsStats:        INITIAL_STATE.brandsStats,
        brandsStatsError:   action.payload
      };

    // ── Brand Category ─────────────────────────
    case FETCH_ADMIN_BRAND_CATEGORY_STATS_LOADING:
      return {
        ...state,
        loadingBrandCategoryStats: true,
        brandCategoryStatsError:   null
      };

    case FETCH_ADMIN_BRAND_CATEGORY_STATS_SUCCESS:
      return {
        ...state,
        loadingBrandCategoryStats: false,
        brandCategoryStats:        action.payload,
        brandCategoryStatsError:   null
      };

    case FETCH_ADMIN_BRAND_CATEGORY_STATS_FAIL:
      return {
        ...state,
        loadingBrandCategoryStats: false,
        brandCategoryStats:        INITIAL_STATE.brandCategoryStats,
        brandCategoryStatsError:   action.payload
      };

    // ── Blog/News ────────────────────────────────
    case FETCH_ADMIN_BLOG_STATS_LOADING:
      return {
        ...state,
        loadingBlogStats: true,
        blogStatsError:   null
      };

    case FETCH_ADMIN_BLOG_STATS_SUCCESS:
      return {
        ...state,
        loadingBlogStats: false,
        blogStats:        action.payload,
        blogStatsError:   null
      };

    case FETCH_ADMIN_BLOG_STATS_FAIL:
      return {
        ...state,
        loadingBlogStats: false,
        blogStats:        INITIAL_STATE.blogStats,
        blogStatsError:   action.payload
      };

    // ── Blog/News View Statistic ────────────────
    case FETCH_ADMIN_BLOG_NEWS_STATS_LOADING:
      return {
        ...state,
        loadingBlogNewsStats: true,
        blogNewsStatsError:   null
      };

    case FETCH_ADMIN_BLOG_NEWS_STATS_SUCCESS:
      return {
        ...state,
        loadingBlogNewsStats: false,
        blogNewsStats:        action.payload,
        blogNewsStatsError:   null
      };

    case FETCH_ADMIN_BLOG_NEWS_STATS_FAIL:
      return {
        ...state,
        loadingBlogNewsStats: false,
        blogNewsStats:        INITIAL_STATE.blogNewsStats,
        blogNewsStatsError:   action.payload
      };

          // ── Full User Rows (admin‐additional-api?table=user) ─────
    case FETCH_ADMIN_USER_ADDITIONAL_LOADING:
      return {
        ...state,
        loadingUserAdditionalData: true,
        userAdditionalDataError:   null
      };

    case FETCH_ADMIN_USER_ADDITIONAL_SUCCESS:
      return {
        ...state,
        loadingUserAdditionalData: false,
        userAdditionalData:        action.payload,
        userAdditionalDataError:   null
      };

    case FETCH_ADMIN_USER_ADDITIONAL_FAIL:
      return {
        ...state,
        loadingUserAdditionalData: false,
        userAdditionalData:        [],          // reset on failure
        userAdditionalDataError:   action.payload
      };

    case FETCH_ADMIN_CURATED_RECIPES_ADDL_LOADING:
      return {
        ...state,
        loadingCuratedRecipesAdditionalData: true,
        curatedRecipesAdditionalDataError:   null
      };

    case FETCH_ADMIN_CURATED_RECIPES_ADDL_SUCCESS:
      return {
        ...state,
        loadingCuratedRecipesAdditionalData: false,
        curatedRecipesAdditionalData:        action.payload,
        curatedRecipesAdditionalDataError:   null
      };

    case FETCH_ADMIN_CURATED_RECIPES_ADDL_FAIL:
      return {
        ...state,
        loadingCuratedRecipesAdditionalData: false,
        curatedRecipesAdditionalData:        [],         // reset on fail
        curatedRecipesAdditionalDataError:   action.payload
      };

    case FETCH_ADMIN_CUSTOM_RECIPES_ADDL_LOADING:
      return {
        ...state,
        loadingCustomRecipesAdditionalData: true,
        customRecipesAdditionalDataError:   null
      };

    case FETCH_ADMIN_CUSTOM_RECIPES_ADDL_SUCCESS:
      return {
        ...state,
        loadingCustomRecipesAdditionalData: false,
        customRecipesAdditionalData:        action.payload,
        customRecipesAdditionalDataError:   null
      };

    case FETCH_ADMIN_CUSTOM_RECIPES_ADDL_FAIL:
      return {
        ...state,
        loadingCustomRecipesAdditionalData: false,
        customRecipesAdditionalData:        [],
        customRecipesAdditionalDataError:   action.payload
      };

    case FETCH_ADMIN_MAKE_RECIPE_ADDL_LOADING:
      return {
        ...state,
        loadingMakeRecipeAdditionalData: true,
        makeRecipeAdditionalDataError:   null
      };

    case FETCH_ADMIN_MAKE_RECIPE_ADDL_SUCCESS:
      return {
        ...state,
        loadingMakeRecipeAdditionalData: false,
        makeRecipeAdditionalData:        action.payload,
        makeRecipeAdditionalDataError:   null
      };

    case FETCH_ADMIN_MAKE_RECIPE_ADDL_FAIL:
      return {
        ...state,
        loadingMakeRecipeAdditionalData: false,
        makeRecipeAdditionalData:        [],
        makeRecipeAdditionalDataError:   action.payload
      };

   // ——— Like‐Recipe cases ———
    case FETCH_LIKE_RECIPE_ADDITIONAL_REQUEST:
      return {
        ...state,
        loadingLikeRecipeAdditionalData: true,
        likeRecipeAdditionalDataError: null
      };

    case FETCH_LIKE_RECIPE_ADDITIONAL_SUCCESS:
      return {
        ...state,
        loadingLikeRecipeAdditionalData: false,
        likeRecipeAdditionalData: action.payload
      };

    case FETCH_LIKE_RECIPE_ADDITIONAL_FAIL:
      return {
        ...state,
        loadingLikeRecipeAdditionalData: false,
        likeRecipeAdditionalDataError: action.payload
      };


    case FETCH_VIEW_RECIPE_ADDITIONAL_REQUEST:
      return {
        ...state,
        loadingViewRecipeAdditionalData: true,
        viewRecipeAdditionalDataError: null
      };

    case FETCH_VIEW_RECIPE_ADDITIONAL_SUCCESS:
      return {
        ...state,
        loadingViewRecipeAdditionalData: false,
        viewRecipeAdditionalData: action.payload
      };

    case FETCH_VIEW_RECIPE_ADDITIONAL_FAIL:
      return {
        ...state,
        loadingViewRecipeAdditionalData: false,
        viewRecipeAdditionalDataError: action.payload
      };

    case FETCH_ADMIN_BRAND_ADDITIONAL_LOADING:
      return {
        ...state,
        loadingBrandAdditionalData: true,
        brandAdditionalDataError:   null
      };

    case FETCH_ADMIN_BRAND_ADDITIONAL_SUCCESS:
      return {
        ...state,
        loadingBrandAdditionalData: false,
        brandAdditionalData:        action.payload,
        brandAdditionalDataError:   null
      };

    case FETCH_ADMIN_BRAND_ADDITIONAL_FAIL:
      return {
        ...state,
        loadingBrandAdditionalData: false,
        brandAdditionalData:        [],   // reset on failure
        brandAdditionalDataError:   action.payload
      };

    case FETCH_ADMIN_BRAND_CATEGORY_ADDITIONAL_LOADING:
      return {
        ...state,
        loadingBrandCategoryAdditionalData: true,
        brandCategoryAdditionalDataError:   null
      };

    case FETCH_ADMIN_BRAND_CATEGORY_ADDITIONAL_SUCCESS:
      return {
        ...state,
        loadingBrandCategoryAdditionalData: false,
        brandCategoryAdditionalData:        action.payload,
        brandCategoryAdditionalDataError:   null
      };

    case FETCH_ADMIN_BRAND_CATEGORY_ADDITIONAL_FAIL:
      return {
        ...state,
        loadingBrandCategoryAdditionalData: false,
        brandCategoryAdditionalData:        [],    // reset on failure
        brandCategoryAdditionalDataError:   action.payload
      };

          case FETCH_ADMIN_BLOG_ADDITIONAL_LOADING:
      return {
        ...state,
        loadingBlogAdditionalData: true,
        blogAdditionalDataError:   null
      };

    case FETCH_ADMIN_BLOG_ADDITIONAL_SUCCESS:
      return {
        ...state,
        loadingBlogAdditionalData: false,
        blogAdditionalData:        action.payload,
        blogAdditionalDataError:   null
      };

    case FETCH_ADMIN_BLOG_ADDITIONAL_FAIL:
      return {
        ...state,
        loadingBlogAdditionalData: false,
        blogAdditionalData:        [],   // reset on error
        blogAdditionalDataError:   action.payload
      };

        case FETCH_ADMIN_BLOG_STATISTICS_ADDITIONAL_LOADING:
      return {
        ...state,
        loadingBlogStatisticsAdditionalData: true,
        blogStatisticsAdditionalDataError:   null
      };

    case FETCH_ADMIN_BLOG_STATISTICS_ADDITIONAL_SUCCESS:
      return {
        ...state,
        loadingBlogStatisticsAdditionalData: false,
        blogStatisticsAdditionalData:        action.payload,
        blogStatisticsAdditionalDataError:   null
      };

    case FETCH_ADMIN_BLOG_STATISTICS_ADDITIONAL_FAIL:
      return {
        ...state,
        loadingBlogStatisticsAdditionalData: false,
        blogStatisticsAdditionalData:        [],    // reset on fail
        blogStatisticsAdditionalDataError:   action.payload
      };

    default:
      return state;
  }
};

export default dashboardAdminReducer;
